import { render, staticRenderFns } from "./full-rule.vue?vue&type=template&id=56e0750a&scoped=true&"
import script from "./full-rule.vue?vue&type=script&lang=ts&"
export * from "./full-rule.vue?vue&type=script&lang=ts&"
import style0 from "./full-rule.vue?vue&type=style&index=0&id=56e0750a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0750a",
  null
  
)

export default component.exports